import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { differenceInWeeks, differenceInMonths, differenceInYears, parseISO, format } from "date-fns"
import { PlaceHolderImages } from "./placeholder-images"

export function getPlaceholderImage(hint: string) {
    const h = hint.toLowerCase();
    const found = PlaceHolderImages.find(img => h.includes(img.imageHint.toLowerCase()));
    return found ? found.imageUrl : 'https://placehold.co/800x600?text=Premium+Puppy';
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function formatAge(dob: string | undefined, isEstimated: boolean = false): string {
    if (!dob) return 'N/A';

    try {
        const birthDate = parseISO(dob);
        const now = new Date();

        const years = differenceInYears(now, birthDate);
        const months = differenceInMonths(now, birthDate);
        const weeks = differenceInWeeks(now, birthDate);

        let ageStr = '';
        if (years > 0) {
            ageStr = `${years} year${years > 1 ? 's' : ''}`;
        } else if (months > 0) {
            ageStr = `${months} month${months > 1 ? 's' : ''}`;
        } else if (weeks > 0) {
            ageStr = `${weeks} week${weeks > 1 ? 's' : ''}`;
        } else {
            ageStr = 'Newborn';
        }

        return isEstimated ? `Est. ${ageStr}` : ageStr;
    } catch (e) {
        return dob; // Fallback to raw string if parsing fails
    }
}

export function formatBirthdate(dob: string | undefined, isEstimated: boolean = false): string {
    if (!dob) return 'N/A';
    try {
        const date = parseISO(dob);
        const formatted = format(date, "MMM d, yyyy");
        return isEstimated ? `Est. ${formatted}` : formatted;
    } catch (e) {
        return dob;
    }
}
